import type { KeyboardEvent } from "react";

/**
 * Native <button> elements fire their click handler on Enter and Space, but a
 * <div role="button"> does not — it can be focused with Tab and then does
 * nothing. Spread this alongside role="button" and tabIndex={0} so those
 * elements behave the way keyboard users expect.
 *
 *   <div role="button" tabIndex={0} onClick={open} onKeyDown={onActivate(open)}>
 */
export const onActivate =
  (handler: () => void) =>
  (event: KeyboardEvent<HTMLElement>): void => {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    event.stopPropagation();
    handler();
  };
